import { NON_BILLABLE_OPTIONS } from "contexts/Call/Form/constants"
import { VALIDATION_FAILURES } from "hooks/useValidation"

export const nonBilableReasonsOptions = Object.values(NON_BILLABLE_OPTIONS).map((opt) => ({
  text: opt.text,
  value: opt.key,
}))

const _departmentValidation = (evt) => {
  if (!evt.target.value) {
    return VALIDATION_FAILURES.REQUIRED
  }
  return null
}

export const departmentValidation = {
  onChange: _departmentValidation,
}

